var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitlab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 93,
    viewBox: "0 0 101 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3807 92.3557L68.7936 35.687H31.9674L50.3803 92.3557H50.3807Z",
    fill: "#E24329"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3807 92.3554L31.9674 35.6865H6.16257L50.3807 92.3554Z",
    fill: "#FC6D26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16255 35.6865L0.567229 52.908C0.318444 53.6736 0.31841 54.4983 0.567131 55.2639C0.815853 56.0295 1.30056 56.6968 1.95179 57.17L50.3806 92.3557L6.16216 35.6869L6.16255 35.6865Z",
    fill: "#FCA326"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16257 35.6867H31.9674L20.878 1.55537C20.3073 -0.200943 17.8227 -0.200552 17.2524 1.55537L6.16257 35.6867Z",
    fill: "#E24329"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3807 92.3554L68.7936 35.6865H94.5989L50.3803 92.3554H50.3807Z",
    fill: "#FC6D26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5988 35.6865L100.194 52.908C100.443 53.6736 100.443 54.4984 100.194 55.264C99.9452 56.0296 99.4604 56.6968 98.8091 57.17L50.3807 92.3557L94.5988 35.6869V35.6865Z",
    fill: "#FCA326"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5989 35.6867H68.7936L79.8834 1.55537C80.4542 -0.200943 82.9387 -0.200552 83.509 1.55537L94.5989 35.6867Z",
    fill: "#E24329"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.baae871d007dcfa4bf01345caa91b8af.svg";
export { ForwardRef as ReactComponent };